<template>
  <section class="howToRead">
    <h1>
      {{ $t("surveyResult.howToReadTitle") }}
    </h1>
    <h2>{{ $t("surveyResult.howToRead2022.title1") }}</h2>
    <p>{{ $t("surveyResult.howToRead2022.section1.p1") }}</p>
    <p>{{ $t("surveyResult.howToRead2022.section1.p2") }}</p>
    <p>{{ $t("surveyResult.howToRead2022.section1.p3") }}</p>
    <p>{{ $t("surveyResult.howToRead2022.section1.p4") }}</p>
    <ul>
      <li>
        <h3>1) {{ $t("surveyResult.howToRead2022.section1.axis1-title") }}</h3>
        <p>{{ $t("surveyResult.howToRead2022.section1.axis1-p") }}</p>
      </li>
      <li>
        <h3>2) {{ $t("surveyResult.howToRead2022.section1.axis2-title") }}</h3>
        <p>{{ $t("surveyResult.howToRead2022.section1.axis2-p") }}</p>
      </li>
      <li>
        <h3>3) {{ $t("surveyResult.howToRead2022.section1.axis3-title") }}</h3>
        <p>{{ $t("surveyResult.howToRead2022.section1.axis3-p") }}</p>
      </li>
      <li>
        <h3>4) {{ $t("surveyResult.howToRead2022.section1.axis4-title") }}</h3>
        <p>{{ $t("surveyResult.howToRead2022.section1.axis4-p1") }}</p>
        <p>{{ $t("surveyResult.howToRead2022.section1.axis4-p2") }}</p>
      </li>
    </ul>
    <table>
      <tr class="border-b">
        <th>{{ $t("surveyResult.howToRead2022.section1.axis") }}</th>
        <td>{{ $t("surveyResult.howToRead2022.section1.thematics") }}</td>
      </tr>
      <tr class="border2-b">
        <th>{{ $t("surveyResult.howToRead2022.section1.axis1-title") }}</th>
        <td>
          <ul>
            <li>{{ $t("surveyResult.howToRead2022.section1.axis1-table-td.item1") }}</li>
            <li>{{ $t("surveyResult.howToRead2022.section1.axis1-table-td.item2") }}</li>
            <li>{{ $t("surveyResult.howToRead2022.section1.axis1-table-td.item3") }}</li>
            <li>{{ $t("surveyResult.howToRead2022.section1.axis1-table-td.item4") }}</li>
            <li>{{ $t("surveyResult.howToRead2022.section1.axis1-table-td.item5") }}</li>
            <li>{{ $t("surveyResult.howToRead2022.section1.axis1-table-td.item6") }}</li>
            <li>{{ $t("surveyResult.howToRead2022.section1.axis1-table-td.item7") }}</li>
            <li>{{ $t("surveyResult.howToRead2022.section1.axis1-table-td.item8") }}</li>
          </ul>
        </td>
      </tr>
      <tr class="border2-b">
        <th>{{ $t("surveyResult.howToRead2022.section1.axis2-title") }}</th>
        <td>
          <ul>
            <li>{{ $t("surveyResult.howToRead2022.section1.axis2-table-td.item1") }}</li>
            <li>{{ $t("surveyResult.howToRead2022.section1.axis2-table-td.item2") }}</li>
            <li>{{ $t("surveyResult.howToRead2022.section1.axis2-table-td.item3") }}</li>
            <li>{{ $t("surveyResult.howToRead2022.section1.axis2-table-td.item4") }}</li>
            <li>{{ $t("surveyResult.howToRead2022.section1.axis2-table-td.item5") }}</li>
            <li>{{ $t("surveyResult.howToRead2022.section1.axis2-table-td.item6") }}</li>
          </ul>
        </td>
      </tr>
      <tr class="border2-b">
        <th>{{ $t("surveyResult.howToRead2022.section1.axis3-title") }}</th>
        <td>
          <ul>
            <li>{{ $t("surveyResult.howToRead2022.section1.axis3-table-td.item1") }}</li>
            <li>{{ $t("surveyResult.howToRead2022.section1.axis3-table-td.item2") }}</li>
            <li>{{ $t("surveyResult.howToRead2022.section1.axis3-table-td.item3") }}</li>
            <li>{{ $t("surveyResult.howToRead2022.section1.axis3-table-td.item4") }}</li>
            <li>{{ $t("surveyResult.howToRead2022.section1.axis3-table-td.item5") }}</li>
            <li>{{ $t("surveyResult.howToRead2022.section1.axis3-table-td.item6") }}</li>
            <li>{{ $t("surveyResult.howToRead2022.section1.axis3-table-td.item7") }}</li>
          </ul>
        </td>
      </tr>
      <tr>
        <th>{{ $t("surveyResult.howToRead2022.section1.axis4-title") }}</th>
        <td>
          <ul>
            <li>{{ $t("surveyResult.howToRead2022.section1.axis4-table-td.item1") }}</li>
            <li>{{ $t("surveyResult.howToRead2022.section1.axis4-table-td.item2") }}</li>
            <li>{{ $t("surveyResult.howToRead2022.section1.axis4-table-td.item3") }}</li>
            <li>{{ $t("surveyResult.howToRead2022.section1.axis4-table-td.item4") }}</li>
          </ul>
        </td>
      </tr>
    </table>

    <h2>{{ $t("surveyResult.howToRead2022.title2") }}</h2>
    <p>{{ $t("surveyResult.howToRead2022.section2.p1") }}</p>
    <p>{{ $t("surveyResult.howToRead2022.section2.p2") }}</p>
    <p>{{ $t("surveyResult.howToRead2022.section2.p3") }}</p>
    <p>{{ $t("surveyResult.howToRead2022.section2.p4") }}</p>

    <h2>{{ $t("surveyResult.howToRead2022.title3") }}</h2>
    <p>{{ $t("surveyResult.howToRead2022.section3.p1") }}</p>
    <p>{{ $t("surveyResult.howToRead2022.section3.p2") }}</p>
  </section>
</template>
<script>
export default {
  name: 'HowToRead2022',
};
</script>
<style scoped>
.howToRead h3 {
  font-size: 14px;
  font-weight: bold;
}
.howToRead ol {
  list-style-type: decimal;
}
.howToRead ul {
  list-style-type: none;
}
.howToRead li {
  margin-left: 1em;
}
.htr-warning {
  color: red;
}
table {
  width: 100%;
  margin: 1em 0;
}
table tr.border-b {
  border-bottom: 2px solid black;
}
table tr.border2-b {
  border-bottom: 1px dotted #0d93d2;
}
table ul {
  list-style: "-";
}
table th {
  background-color: #ebf6fd;
  color: #0d93d2;
  font-weight: bold;
  vertical-align: middle;
  text-align: left;
  padding: 0.25em 1em;
}
table td {
  color: #0d93d2;
  padding: 0.25em 1em;
}
</style>
